import { TechDropdownItemInterface } from '../interfaces/tech-dropdown-item.interface';

export class TechDropdownItemModel implements TechDropdownItemInterface {
  label: string;
  value: string;

  constructor(value: string = '', label: string = '') {
    this.label = label;
    this.value = value;
  }
}
